




import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { getDetails , quizStatus } from '../../services/quiz';
import { toast } from "react-hot-toast";
import { generateConfirm } from '../../helpers';



const ViewQuiz = () => {
  const navigate = useNavigate();
  const { quizId } = useParams();
  const [quizData, setQuizData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandedQuestions, setExpandedQuestions] = useState({});
  const [error, setError] = useState(null);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(0);
  const questionsPerPage = 5;


  //quiz fetch
  useEffect(() => {
    const fetchQuizData = async () => {
      setLoading(true);
      try {
        const response = await getDetails(quizId);
        if (response && response.data && response.data.statusCode === 200) {
          setQuizData(response.data.result);
          
          // Initialize all questions to be expanded
          const initialExpandedState = {};
          response.data.result.questions.forEach(question => {
            initialExpandedState[question.question_id] = true;
          });
          setExpandedQuestions(initialExpandedState);
        } else {
          setError('Failed to fetch quiz details');
        }
      } catch (error) {
        console.error('Error fetching quiz details:', error);
        setError('An error occurred while fetching quiz details');
      } finally {
        setLoading(false);
      }
    };

    fetchQuizData();
  }, [quizId]);

  const toggleQuestion = (questionId) => {
    setExpandedQuestions(prev => ({
      ...prev,
      [questionId]: !prev[questionId]
    }));
  };

  const handleEditQuiz = () => {
    navigate(`/edit-quiz/${quizData.quiz_id}`);
  };

  //Delete Quiz
  const updateQuizStatus = async (quizId, newStatus) => {
    try {
      const response = await quizStatus({
        quiz_id: String(quizId),
        status: newStatus,
      });
  
      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.statusMessage || "Status updated successfully");
        navigate("/quiz-list");  // Optional: redirect after deletion
      } else {
        toast.error("Failed to update status");
      }
    } catch (error) {
      toast.error("Error updating status");
    }
  };
  

 

  const handleDeleteQuiz = () => {
    updateQuizStatus(quizData.quiz_id, "2");
   
  };

  

  const parseOptions = (optionsStr) => {
    try {
      return JSON.parse(optionsStr);
    } catch (e) {
      console.error("Error parsing options:", e);
      return [];
    }
  };

  // Handle page change for pagination
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  // Get difficulty level text
  const getDifficultyLevel = (level) => {
    const levels = {
      "0": "Easy",
      "1": "Medium",
      "2": "Hard"
    };
    return levels[level] || "Unknown";
  };

  // Format date for better display
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (loading) {
    return (
      <div className="loading-overlay">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h3>Error</h3>
        <p>{error}</p>
        <button className="btn-purple" onClick={() => navigate('/quiz-list')}>
          Back to Quiz List
        </button>
      </div>
    );
  }

  if (!quizData) {
    return (
      <div className="error-container">
        <h3>No Data Found</h3>
        <p>Could not find quiz details</p>
        <button className="btn-purple" onClick={() => navigate('/quiz-list')}>
          Back to Quiz List
        </button>
      </div>
    );
  }

  // Calculate page count for pagination
  const pageCount = Math.ceil(quizData.questions.length / questionsPerPage);
  
  // Get current questions
  const currentQuestions = quizData.questions.slice(
    currentPage * questionsPerPage,
    (currentPage + 1) * questionsPerPage
  );

  const cleanedHtml = quizData.about_quiz.replace(/<p>\s*&nbsp;\s*<\/p>/g, '');

  return (
    <div className="view-quiz-container">
      {/* Quiz Header */}
      <div className="quiz-title">
        <h1 className="heading-36">Quiz</h1>
        {/* <div className="subheader-right-btm">
          <button className="btn-purple discard" onClick={handleEditQuiz}>
            Edit Quiz
          </button>
          <button className="btn-purple" onClick={() =>
                  generateConfirm(
                    "Are you sure you want to Delete Quiz?",
                    "Press Yes if you want to delete",
                    "quiz-delete",
                    () => handleDeleteQuiz()
                  )
            }>
            Delete
          </button>
        </div> */}
      </div>

      {/* Quiz Details */}
      <div className="quiz-info-card">
        <div className="quiz-info-header">
          <h2 className="quiz-title">{quizData.quiz_name}</h2>
        </div>

        <div className="quiz-details-grid">
          <div className="detail-item">
            <span className="detail-label">Quiz Category</span>
            <span className="detail-value">{quizData.category_name}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Quiz Subcategory</span>
            <span className="detail-value">{quizData.sub_category_name}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">No of questions</span>
            <span className="detail-value">{quizData.no_of_questions}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Created on</span>
            <span className="detail-value">
              {formatDate(quizData.created_at)}
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Total Time</span>
            <span className="detail-value">{quizData.total_time} minutes</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Difficulty Level</span>
            <span className="detail-value">{getDifficultyLevel(quizData.difficulty_level)}</span>
          </div>
        </div>
      </div>

      {/* Description Section */}
      <div className="quiz-section quiz-info-card">
        <h3 className="section-title">About Quiz</h3>
        <div className="section-content">
        <p dangerouslySetInnerHTML={{ __html: cleanedHtml }} />
        </div>
      </div>

      {/* Questions Section */}
      <div className="quiz-section">
        <h3 className="section-title">Questions</h3>
        <div className="quiz-questions-container">
          {currentQuestions.map((question, index) => {
            const options = parseOptions(question.options);
            const isExpanded = expandedQuestions[question.question_id];
            const absoluteIndex = currentPage * questionsPerPage + index;

            return (
              <div 
                key={question.question_id} 
                className={`quiz-question-card ${isExpanded ? 'expanded' : ''}`}
              >
                <div 
                  className="quiz-header" 
                  onClick={() => toggleQuestion(question.question_id)}
                >
                  <h4 className="question-number">Question {absoluteIndex + 1}</h4>
                  <FontAwesomeIcon 
                    icon={faChevronDown} 
                    className={`accordion-icon ${isExpanded ? 'open' : ''}`} 
                  />
                </div>
                
                {isExpanded && (
                  <div className="question-content">
                    <div className="question-text">
                      <p>{question.question}</p>
                      {question.question_file && (
                        <div className="question-image">
                          <img src={question.question_file} alt="Question" />
                        </div>
                      )}
                    </div>
                    
                    <div className="options-grid">
                      {options.map((option, optIndex) => {
                        const isCorrectAnswer = 
                          (option.type === "text" && option.option === question.answer) || 
                          (option.type === "file" && option.option === question.answer);
                        
                        return (
                          <div 
                            key={optIndex} 
                            className={`option-item ${isCorrectAnswer ? 'correct-answer' : ''}`}
                          >
                            <span className="option-label">{String.fromCharCode(65 + optIndex)}.</span>
                            {option.type === "text" ? (
                              <span className="option-text">{option.option}</span>
                            ) : (
                              <div className="option-image">
                                <img src={option.option} alt={`Option ${String.fromCharCode(65 + optIndex)}`} />
                              </div>
                            )}
                            {isCorrectAnswer && (
                              <span className="correct-indicator">Correct Answer</span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        
        {/* Pagination Component */}
        {pageCount > 1 && (
          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination custom-pagination"}
            activeClassName={"active"}
          />
        )}
      </div>
    </div>
  );
};

export default ViewQuiz;